/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Target format for PDF conversion
 */
export enum PdfConversionTargetFormat {
    WORD_DOCUMENT = 'WORD_DOCUMENT',
    POWERPOINT = 'POWERPOINT',
    EXCEL = 'EXCEL',
    AUTO = 'AUTO',
}